import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {checaFormatoSenha} from "../util/utils"
import '../../App.css';

const passwordFormatNotification = {
	weakPassword:  "Senha fraca! A sua senha precisa ter mais de 7 caracteres, letras, números e caracteres especiais.",
	strongPassword: "A sua senha é forte!",
	defaultPassword: "Mais de 7 caracteres, com letras, números e caracteres especiais."
}

const PasswordInput = props => {
	
	const { placeholder, senha, onChangeFunc, titleTooltip, tooltipPosition, checkPassword } = props;

	const [senhaForte, setSenhaForte] = useState(null)

	useEffect(() => {
		if(senha?.length > 0) setSenhaForte(checaFormatoSenha(senha))				  
	}, [senha]);

	function mostrarSenha(){
		let passwordInput = document.getElementById("senha");
		if(passwordInput.type === "password"){
			passwordInput.type = "text"
		}else{
			passwordInput.type = "password"
		}
	}

	let senhaStatus
	if(checkPassword){
		if(senha?.length){
			senhaStatus = senhaForte ? <small style={{color: "#4fa746"}}>{passwordFormatNotification.strongPassword}</small> : <small style={{color: "#da3646"}}>{passwordFormatNotification.weakPassword}</small>;
		}else{
			senhaStatus = <small>{passwordFormatNotification.defaultPassword}</small>
		}
	}

	//console.log(senhaStatus)

	return(
		<>
			<div className="input-group mb-2 mr-sm-2">							
				<input id="senha" placeholder={placeholder || ''} type="password" name="senha" className="form-control shadow-none" value={senha || ''} onChange={(e) => onChangeFunc(e)}/>
				<div id="mostrar-senha" className="input-group-prepend" onClick={() => mostrarSenha()} datatoggle="tooltip" dataplacement={tooltipPosition || 'top'} title={titleTooltip || 'show password'}>
					<div className="input-group-text">						
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye-fill" viewBox="0 0 16 16">
								<path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
								<path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
							</svg>			
					</div>
				</div>
			</div>
			{checkPassword && <div>{senhaStatus}</div>}
		</>
	)
	
}


PasswordInput.propTypes = {
	senha: PropTypes.string,
	placeholder: PropTypes.string,
	tooltipPosition: PropTypes.string,
	titleTooltip: PropTypes.string,
	onChangeFunc: PropTypes.func.isRequired,
	checkPassword: PropTypes.bool
  }
	

export default PasswordInput;
